export enum EDealTypes {
  FlatSale = 'flatSale',
  FlatRent = 'flatRent',
  SuburbanSale = 'suburbanSale',
  SuburbanRent = 'suburbanRent',
  CommercialSale = 'commercialSale',
  CommercialRent = 'commercialRent',
  NewObjectSale = 'newObjectSale',
  DailyRent = 'dailyRent',
}
